// extracted by mini-css-extract-plugin
module.exports = {"newPostsButton":"newPostsButton___10LEg","bullet":"bullet____GnCX","ampPillButton":"ampPillButton___3vGdg"};